<template>
  <div class="preview-picture" @click="onPreview">
    <img :src="props.image" :alt="props.alt">
  </div>

  <teleport to='body'>
    <ViewImage ref="viewImageRef" />
  </teleport>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import ViewImage from './ViewImage.vue'

// eslint-disable-next-line no-undef
const props = defineProps(['image', 'alt'])

const viewImageRef = ref()

const onPreview = () => {
  viewImageRef.value.open(props.image)
}
</script>

<style lang="less" scoped>
.preview-picture {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;

  img {
    display: block;
    width: 100%;
  }
}
</style>